












/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'CardCanvasTwoDeepBreadcrumb',

  props: {
    parentRoute: {
      type: Object,
      required: true,
    },
    parentName: {
      type: String,
      required: true,
    },
    childName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      RouteAssistant,
    }
  },
})
